import { render, staticRenderFns } from "./personnel_add.vue?vue&type=template&id=5b270c7f&scoped=true&"
import script from "./personnel_add.vue?vue&type=script&lang=js&"
export * from "./personnel_add.vue?vue&type=script&lang=js&"
import style0 from "./personnel_add.vue?vue&type=style&index=0&id=5b270c7f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b270c7f",
  null
  
)

export default component.exports